import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-alert-pergunta',
    templateUrl: './alert-pergunta.component.html',
    styleUrls: ['./alert-pergunta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class AlertPerguntaComponent {

  @Output() alertPerguntaFechou = new EventEmitter();

  constructor() { }

  fecharAlertPergunta(acao: string) {
    this.alertPerguntaFechou.emit(acao);
  }
}
